import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../config/trading";
import { apiErrorMessage } from "../../lib/errorMessage";

export function AuthPanel({ onAuthenticated }) {
  const [adminExists, setAdminExists] = useState(true);
  const [form, setForm] = useState({ email: "", password: "", name: "Admin" });
  const [message, setMessage] = useState("");

  const loadAuthStatus = useCallback(() => {
    axios.get(`${API}/auth/status`).then((response) => setAdminExists(response.data.admin_exists)).catch(() => setMessage("Auth status unavailable."));
  }, [setAdminExists, setMessage]);

  useEffect(() => {
    loadAuthStatus();
  }, [loadAuthStatus]);

  const submit = async () => {
    setMessage("");
    try {
      const endpoint = adminExists ? "/auth/login" : "/auth/setup";
      const payload = adminExists ? { email: form.email, password: form.password } : form;
      const response = await axios.post(`${API}${endpoint}`, payload);
      onAuthenticated(response.data);
    } catch (err) {
      setMessage(apiErrorMessage(err, "Authentication failed."));
    }
  };

  return (
    <main className="terminal-shell auth-shell" data-testid="auth-panel">
      <section className="panel auth-card">
        <span className="label">OKXSTREAM DASHBOARD</span>
        <h1 data-testid="auth-title">{adminExists ? "Sign In" : "Create Admin"}</h1>
        {!adminExists && <input data-testid="setup-name-input" className="terminal-input" placeholder="Admin name" value={form.name} onChange={(event) => setForm((current) => ({ ...current, name: event.target.value }))} />}
        <input data-testid="auth-email-input" className="terminal-input stacked" type="email" placeholder="Email" value={form.email} onChange={(event) => setForm((current) => ({ ...current, email: event.target.value }))} />
        <input data-testid="auth-password-input" className="terminal-input stacked" type="password" placeholder="Password" value={form.password} onChange={(event) => setForm((current) => ({ ...current, password: event.target.value }))} />
        <button data-testid="auth-submit-button" className="primary-button wide" onClick={submit}>{adminExists ? "Login" : "Create Admin Account"}</button>
        {message && <p data-testid="auth-message" className="notice">{message}</p>}
      </section>
    </main>
  );
}